<div class="col-lg-6 col-xs-12">

    <div class="panel panel-default">
        <div class="panel-body">


<div class="row">
  <div class="col-xs-12">
    <div style="display: block;">
    <canvas baseChart width="400" height="400"
                [datasets]="lineChartData"
                [labels]="lineChartLabels"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [legend]="lineChartLegend"
                [chartType]="lineChartType"
                ></canvas>
    </div>
  </div>
  <div class="col-xs-12" style="margin-bottom: 10px">
    <table class="table table-responsive table-condensed">
      <tr>
        <th *ngFor="let label of lineChartLabels">{{label}}</th>
      </tr>
      <tr *ngFor="let d of lineChartData">
        <td *ngFor="let label of lineChartLabels; let j=index">{{d && d.data[j]}}</td>
      </tr>
    </table>
  </div>
</div>

</div>
</div>
</div>




// WEBPACK FOOTER //
// ./src/app/report/charts/line-chart-with-table/line-chart-with-table.component.html